<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits, useSlots, computed } from 'vue';

import TelaBase from '@/components/v2/base/TelaBase/TelaBase.vue';
import CartaoTabelaBase from '@/components/v2/base/CartaoTabelaBase/CartaoTabelaBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false
    },
    headers: {
        type: Array,
        default: () => []
    },
    dados: {
        type: Array,
        default: () => []
    },
    selecao: {
        type: String,
        default: 'nenhum'
    },
    selecionados: {
        type: Array,
        default: () => []
    },
    selecionado: {
        type: Object,
        default: () => ({})
    },
    itemKey: {
        type: String,
        default: 'id'
    },
    paginacao: {
        type: String,
        default: 'nenhuma'
    },
    itensPorPagina: {
        type: Number,
        default: 10
    }
});

const emits = defineEmits([
    'update:selecionados',
    'update:selecionado',
]);

const slots = useSlots();

/*==================================================================*/
/*================== ALTERA SELECIONADOS/SELECIONADO ================*/
/*==================================================================*/

const alteraSelecionados = (selecionados) => {

    emits('update:selecionados', selecionados);

};

const alteraSelecionado = (selecionado) => {

    emits('update:selecionado', selecionado);

};

/*==================================================================*/
/*================== SLOTS DE ITEM =================================*/
/*==================================================================*/

const slotsDeItem = computed(() =>

    Object.keys(slots).filter(name => name.startsWith('tabela-linha-item.'))

);

const mapearSlot = (name) => name.replace('tabela-linha-item.', 'linha-item.');

</script>

<template>

    <TelaBase :disabled="props.disabled">

        <template #tela-titulo>
            <slot name="tela-titulo"></slot>
        </template>

        <CartaoTabelaBase
            :headers="props.headers"
            :dados="props.dados"
            :disabled="props.disabled"
            :selecao="props.selecao"
            :selecionados="props.selecionados"
            :selecionado="props.selecionado"
            :item-key="props.itemKey"
            :paginacao="props.paginacao"
            :itens-por-pagina="props.itensPorPagina"
            @update:selecionados="alteraSelecionados"
            @update:selecionado="alteraSelecionado"
        >

            <template #header>
                <slot name="card-header"></slot>
            </template>

            <template v-if="slots['tabela-linha-botoes']" #linha-botoes="slotProps">
                <slot name="tabela-linha-botoes" v-bind="slotProps"></slot>
            </template>

            <template
                v-for="name in slotsDeItem"
                #[mapearSlot(name)]="slotProps"
            >

                <slot :name="name" v-bind="slotProps ?? {}"></slot>

            </template>

            <template #footer>
                <slot name="card-footer"></slot>
            </template>

        </CartaoTabelaBase>

        <slot name="modais"></slot>

    </TelaBase>

</template>

<style scoped>
</style>
